import React from 'react'
import { CaretDownOutlined } from '@ant-design/icons';
import { Select } from 'antd';

const Option = Select.Option;

/**
 * 公众号下拉菜单选择器
 * 示例： <SubsSelector data={this.state.subs} defaultValue={0} onChange={this.subsChange}/>
 *
 */
class SubsSelector extends React.Component {

    constructor(props) {
        super(props);
        this.selected = this.selected.bind(this);
        this.state = {
            data: this.props.data ? this.props.data : [],
            value: props.defaultValue
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            data: nextProps.data,
            value: nextProps.value ? nextProps.value : 0
        })
    }

    selected(value) {
        this.setState({
            value: value
        })
        if (this.props.onChange) {
            this.props.onChange(value);
        }

    }

    render() {
        return this.props.data && this.props.data.length > 0 ?
            <Select className="select-subs" onChange={this.selected}
                    getPopupContainer={this.props.getPopupContainer ? this.props.getPopupContainer : ''}
                    placeholder={this.props.placeholder}
                    defaultValue={this.props.defaultValue}
                    value={this.state.value}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                        return (
                            option.props.content.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        )
                    }
                    }
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    suffixIcon={<CaretDownOutlined />}
                    disabled={this.props.disabled}
            >
                {
                    this.state.data.map(function (subs, i) {
                        return (
                            <Option value={i} content={subs.nickName}>
                                <div className='select-subs-option'>
                                <span>
                                    {subs.nickName}
                                </span>
                                    <div className="select-substag-type">
                                        {
                                            subs.serviceType == 2 ? <i className="icon-fu"></i> :
                                                <i className="icon-ding"></i>
                                        }
                                        <i className="icon-subsauthed"></i>
                                    </div>
                                </div>
                            </Option>
                        )
                    })
                }
            </Select> : <Select className="select-subs" onChange={this.selected}></Select>;
    }
}

export default SubsSelector